export const getInitials = ({
  firstname,
  lastname,
}: {
  firstname?: string;
  lastname?: string;
}) => {
  if (firstname && lastname) {
    return `${firstname[0]}${lastname[0]}`.toUpperCase();
  } else if (!firstname && lastname) {
    return `${lastname[0]}${lastname[1] ?? ''}`.toUpperCase();
  } else if (!lastname && firstname) {
    return `${firstname[0]}${firstname[1] ?? ''}`.toUpperCase();
  }

  return '';
};
